export default function disableClipboard(editor) {
  const editingView = editor.editing.view;
  editingView.document.on('clipboardInput', (event, data) => {
    event.stop();
    return false;
  });
}
